export enum RequestStatusEnum {
  Pending = 1,
  Approved = 2,
  Cancelled = 3,
  Rejected = 4,
}

export interface RequestStatusEnumDisplayNames {
  [key: number]: string;
}

export const RequestStatusEnumDisplayNames: RequestStatusEnumDisplayNames = {
  [RequestStatusEnum.Pending]: 'في انتظار الاعتماد',
  [RequestStatusEnum.Approved]: 'معتمد',
  [RequestStatusEnum.Cancelled]: 'ملغى',
  [RequestStatusEnum.Rejected]: 'مرفوض',
};
